import get from 'lodash/get';

import * as Types from './types';

export const Network = (item?): Types.IEntity.Network => ({
  id: get(item, 'id') || '',
  url: get(item, 'url') || '',
  photoId: get(item, 'fileId') || null
})